import type { Dict } from '@aviata/platform-types';
import type { ticketDetails } from 'shared';

const getAirportCountry = (
  dict: Dict.Entity | null,
  iata: string | undefined,
) => {
  if (!iata) {
    return null;
  }
  return dict?.airports?.[iata]?.city?.country?.iso_code ?? null;
};

/**
 * Transit visa hint is shown when the layover happens in a third country — the
 * connection airport's country differs from both the journey's origin and its
 * final destination. Returns false when countries can't be resolved from dict.
 */
export const needsTransitVisaAtConnection = (
  flight: ticketDetails.types.MappedFlight,
  connectionSegmentIdx: number,
  dict: Dict.Entity | null,
) => {
  const { segments } = flight;
  if (segments.length < 2) {
    return false;
  }

  const layoverCountry = getAirportCountry(
    dict,
    segments[connectionSegmentIdx]?.arr?.airport,
  );
  if (!layoverCountry) {
    return false;
  }

  const originCountry = getAirportCountry(dict, segments[0]?.dep?.airport);
  const destinationCountry = getAirportCountry(
    dict,
    segments[segments.length - 1]?.arr?.airport,
  );

  return (
    layoverCountry !== originCountry && layoverCountry !== destinationCountry
  );
};
